var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.translatedTypes
      ? _c(
          "a",
          {
            staticClass: "email-related-object",
            class: { "no-link": !_vm.object.url },
            attrs: { href: _vm.object.url, target: "_blank" }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "email-related-object__label typographies-paragraph-small-semibold"
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.EmailAttachTo) + " :\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm.iconType
              ? _c("CompassIcon", {
                  attrs: { icon: _vm.iconType, size: "small" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "email-related-object__object typographies-paragraph-small-semibold"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.capitalizeFirstLetter) +
                    "\n        "
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }